import { View, TouchableOpacity } from "react-native";
import { useRouter } from "expo-router";
import { ExternalLink } from "lucide-react-native";
import SettingsCard from "../common/settings-card";
import StyledText from "../../../common/ui/styled-text";
import { posthog } from "posthog-js";

const IntegrationSettings = () => {
  const router = useRouter();

  const handleNavigateToIntegrations = () => {
    posthog.capture("navigate_to_integrations");
    router.push("/integrations");
  };

  return (
    <SettingsCard title="Integrations">
      <View className="flex-row items-center justify-between">
        <View className="flex-1">
          <StyledText className="text-gray-600 text-sm">
            Configure your third party integrations
          </StyledText>
        </View>
        <TouchableOpacity
          onPress={handleNavigateToIntegrations}
          className="flex-row items-center gap-1 px-3 py-2 rounded-md hover:bg-gray-50"
          activeOpacity={0.7}
        >
          <StyledText className="text-gray-500 text-sm">Manage</StyledText>
          <ExternalLink size={14} color="#6B7280" />
        </TouchableOpacity>
      </View>
    </SettingsCard>
  );
};

export default IntegrationSettings;
